module.exports = __webpack_public_path__ + "img/ic_like.5ed0acae.svg";